import { render, staticRenderFns } from "./TheAppSnackbar.vue?vue&type=template&id=2f30a156"
import script from "./TheAppSnackbar.vue?vue&type=script&lang=js"
export * from "./TheAppSnackbar.vue?vue&type=script&lang=js"
import style0 from "./TheAppSnackbar.vue?vue&type=style&index=0&id=2f30a156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports